// Module
var code = "<client-recos ng-if=$ctrl.canInit component-is-ready=$ctrl.componentIsReady() redirect=$ctrl.redirect(url) slider-message=$ctrl.sliderMessage(message) scroll-to-messages=$ctrl.scrollToMessages id=$ctrl.id></client-recos>";
// Exports
module.exports = code;